import { Box, SxProps, Theme } from '@mui/material';
import { Link, useRouteError } from 'react-router-dom';
import routeConstants from '../../shared/constants/Routes';

const errorStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100dvh',
};

const ErrorBoundary = () => {
  let error = useRouteError();

  return (
    <Box sx={errorStyle}>
      <p>Oops, an error has occured.</p>
      <div>
        <Link to={routeConstants.HOME.path}>Return to home</Link>
      </div>
    </Box>
  );
};

export default ErrorBoundary;
